import React from 'react';
import { FormattedMessage } from 'react-intl';
import fieldKeys from './fieldKeys';
import failureReasons from './holdFailureReasons';
import mcLink from './mcLink';

export default {
    [fieldKeys.barHeaderTitleSent]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.header.title_sent"
            defaultMessage="Hold Requests Sent!"
        />
    ),
    [fieldKeys.barHeaderTitleFailed]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.header.title_failed"
            defaultMessage="Hold Requests Failed"
        />
    ),
    [fieldKeys.barHeaderSubtitle]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.header.subtitle"
            defaultMessage="The seller(s) will respond to your requests via {mcLink}"
            values={{ mcLink }}
        />
    ),
    [fieldKeys.successHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.listHeader.success"
            defaultMessage="Hold Requests successfully sent for:"
        />
    ),
    [fieldKeys.failHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.listHeader.fail"
            defaultMessage="Hold requests failed to send for:"
        />
    ),
    failureReasons,
};
